export enum SignInStrings {
  // Messages
  DoNotHavePermission = 'seHn',
  UserNotFound = '9BK+',
  EmployeeInactive = 'sYDc',
}
